/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseOfString } from '../../models/api-response-of-string';

export interface UserResetForgotPassword$Params {
  uName?: string | null;
  Password?: string | null;
}

export function userResetForgotPassword(http: HttpClient, rootUrl: string, params?: UserResetForgotPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOfString>> {
  const rb = new RequestBuilder(rootUrl, userResetForgotPassword.PATH, 'patch');
  if (params) {
    rb.query('uName', params.uName, {});
    rb.query('Password', params.Password, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseOfString>;
    })
  );
}

userResetForgotPassword.PATH = '/user/resetlforgotpassword';
